module.exports = __webpack_public_path__ + "img/KarlusMorales_Imagotype_Short_Dark.100e33db.svg";